import {GraphApiHits, OrganizationUser} from "../../model/api"

export const mapOrganizationUserToString = (hit: OrganizationUser, index: number): string => {
    const {resource} = hit;
    const {jobTitle, displayName, phones, companyName, department} = resource;
    return `**Person ${index + 1}**:
 - Rank: ${hit.rank}
- Display name: ${displayName || "N/A"}
- Job Title: ${jobTitle || "N/A"}
- Company name: ${companyName || "N/A"}
- Department: ${department || "N/A"}
- Phones: ${phones?.length ? phones.map(phone => `${phone.type}: ${phone.number}`).join(", ") : "N/A"}
- Email: ${resource.imAddress ? resource.imAddress.split(":")[1] : resource.userPrincipalName}
- Kid: ${resource.userPrincipalName}`
}

const mappersByClassSubclass = [{
    class: "Person",
    subclass: "OrganizationUser",
    mapperFn: mapOrganizationUserToString,
}]

export const mapGraphApiHitsToString = (hits: GraphApiHits) => {
    return hits.map((hit, index) => {
        const {resource} = hit;
        const mapper = mappersByClassSubclass.find(m => m.class === resource.personType?.class && m.subclass === resource.personType?.subclass);
        if (!mapper) {
            console.error(`No mapper found for class ${resource.personType?.class} and subclass ${resource.personType?.subclass}`);
            return `**Person ${index + 1}**: No mapper found for this person type.`;
        }
        return mapper.mapperFn(hit as any, index)
    }).join("\n");
}